module.exports = __webpack_public_path__ + "static/complex_scroll_7-314cbd10dd536f5e3cf5958d7648583c.png";